// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__RiAts","content":"About_content__Akl_x","title":"About_title__0FwPZ"};